import { COUNTRY_CODE_REGEX } from '@monoimin/constants';

export const checkParagraphContainsOnlyFlag = (
  inputString: string | string[]
) => {
  const regex = new RegExp(COUNTRY_CODE_REGEX, 'g');

  if (typeof inputString === 'string') {
    const resultString = inputString?.replace(regex, '');
    return Boolean(resultString.length < inputString.length);
  }

  return false;
};

export default checkParagraphContainsOnlyFlag;
